import React, { useEffect } from "react";
import { useTestEngineStore } from "./useTestEngineStore";
import Button from "app/components/shared/Button";
import Dropdown from "app/components/shared/Dropdown";
import Icon from "app/components/shared/Icon";
import cable from "app/lib/cable";
import { first, toPairs, get, map, pipe, values } from "lodash/fp";

const testPlanResultSelector = pipe(
  get("testPlans"),
  values,
  first,
  get("statistics.results"),
);

const BktecBadge = ({ buildId }) => {
  const setTestPlan = useTestEngineStore(get("setTestPlan"));
  const testPlanResults = useTestEngineStore(testPlanResultSelector);

  useEffect(() => {
    const subscription = cable.subscriptions.create(
      { channel: "TestEngine::TestPlanChannel", uuid: buildId },
      {
        received({ testPlan }) {
          setTestPlan(testPlan);
        },
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [buildId]);

  return (
    <Dropdown width={200} className="inline-block">
      <Button>
        <Icon icon="down-triangle" style={{ width: 7, height: 7 }} />
      </Button>

      <div className="p-3">
        <dl>
          {pipe(
            toPairs,
            map(([key, value]) => (
              <React.Fragment key={key}>
                <dt>{key}</dt>
                <dd>{value}</dd>
              </React.Fragment>
            )),
          )(testPlanResults)}
        </dl>
      </div>
    </Dropdown>
  );
};

export default BktecBadge;
